<script>
	module.exports = {
		props: ['article', 'assessment']
	};
</script>
<template>
	<div
		class="row margin-bottom-large"
		:class="{ wrapper: assessment }">
		<div class="large-12 columns padding-top-medium">
			<article-ebook :article="article"></article-ebook>
		</div>
	</div>
</template>
